class FormConstants {
  static FIELD_TYPES = {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    RADIO: 'radio',
    SELECT: 'select',
    MULTI_SELECT: 'multi-select',
    MULTI_SELECT_SEARCH: 'multi-select-searchable',
    DATE: 'date',
    MASKED: 'masked',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirm_password',
    CHECKBOX: 'checkbox',
    LIST: 'list',
    ENUM: 'enum',
    OBJECT: 'object',
    EMAIL: 'email'
  };

  static LEGACY_APP = {
    LEGACY_APP: 'LegacyApp',
    FOLDER: 'Folder'
  };

  static GLOBAL_SEARCH = {
    LOCAL_SEARCH: 'LocalSearch',
    local_search: 'local-search',
    ai_search: 'ai-search',
    global_search: 'global-search',
    global_search_tab: 'global_search'
  };

  static INPUT_FIELDS_MAPPING: any = {
    last_name: 'Last Name',
    first_name: 'First Name',
    mrn_no: 'MRN No',
    dob: 'Date of Birth',
    status: 'Status',
    state: 'State',
    social_security_number: 'Social Security Number',
    system_name: 'System Name'
  };

  static INPUT_FIELD_NAMES = {
    LAST_NAME: 'last_name',
    FIRST_NAME: 'first_name',
    MRN_NO: 'mrn_no',
    DOB: 'dob',
    GENDER: 'gender',
    SOCIAL_SECURITY_NUMBER: 'social_security_number',
    SYSTEM_NAME: 'system_name',
    STATUS: 'status',
    STATE: 'state',
    REQUISITION_NUMBER: 'requisition_number',
    PO_NUMBER: 'po_number',
    INVOICE_NUMBER: 'invoice_number',
    VOUCHER_NUMBER: 'voucher_number',
    PAYMENT_NUMBER: 'payment_number',
    VENDOR_NUMBER: 'vendor_number',
    ACCOUNT_NUMBER: 'account_number',
    JOURNAL_NO: 'journal_no',
    CORPORATION_NUMBER: 'corporation_number',
    ITEM_NUMBER: 'item_number',
    CONTRACT_NO: 'contract_no',
    GL_ACCOUNT: 'gl_account',
    EMPLOYEE_NUMBER: 'employee_number',
    SSN: 'ssn',
    LEGACY_APP: 'legacy_app',
    CHARGE_TYPE: 'charge_type',
    TYPE: 'type',
    ACCOUNT_TYPE: 'account_type',
    FIRST_MONTH_YEAR: 'first_month_year',
    END_MONTH_YEAR: 'end_month_year',
    SOURCE_SYSTEM: 'source_system'
  };

  static PAGE_SECTION_TYPES = {
    SEARCH_FORM_TYPE: 'search-form',
    SEARCH_FORM: 'search_form',
    DATA_GRID: 'data-grid',
    CARD: 'card',
    RECORDS: 'records',
    DOCUMENTS: 'documents',
    DICOM: 'dicom',
    SINGLE_DOCUMENT: 'single-document',
    PROFILE: 'profile',
    SELECT: 'select',
    TABS: 'tabs',
    CHART: 'chart',
    PERIODONTAL_CHART: 'periodontal_chart'
  };

  static PERIODONTAL_CHART = {
    UPPER_TEETH: 'upperTeeth'
  };

  static COMPONENT_TYPE = {
    DOCUMENT: 'document'
  };

  static SCREENS = {
    VITAL: 'vital',
    BENEFITS: 'benefits',
    PATIENT_ACCOUNTING: 'patient-accounting',
    REPORTS: 'reports',
    FLOWSHEETS: 'flowsheets',
    FINANCE: 'finance',
    USERS: 'users',
    PREGNENCYHISTORY: 'pregnancy_history',
    LIS: 'lis',
    RIS: 'ris',
    TRANSFUSION: 'transfusion',
    PRODUCTINFO: 'productinfo'
  };

  static CLUMN_NAME = {
    VITAL_NAME: 'VitalName',
    FLOWSHEET_TYPE: 'FlowsheetType',
    PARAMETER_NAME: 'ParameterName'
  };

  static REPORTS_SCREENS = {
    REPORTS: 'reports',
    PREVIOUS_REPORT_TAB: 'previous_report_log',
    NEW_REPORT_TAB: 'new_report',
    CUSTOM_REPORTS: 'custom_reports',
    DOCUMENT_VIEWER_CLINICAL: 'document_viewer_clinical',
    DICOM_VIEWER_CLINICAL: 'dicom_viewer_clinical',
    TAB: 'previous_report_log',
    SUB_TAB: 'previous_report_log_sub_section',
    CREATED_BY_ME: 'created_by_me',
    CREATED_BY_ALL: 'created_by_all',
    ME: 'Created By Me',
    ALL: 'All',
    ALL_VALUE: 'all',
    NONE_VALUE: 'none',
    SELECTED_ENCOUNTERS_ONLY_VALUE: 'for_selected_encounters_only',
    NONE: 'None',
    SELECTED_ENCOUNTERS_ONLY: 'For Selected Encounters Only',
    GENERATE_SUCCESS: 'GENERATE_SUCCESS',
    // VIEW_SUCCESS: 'VIEW_SUCCESS',
    // VIEW_INITIATED: 'VIEW_INITIATED',
    // VIEW_FAILURE: 'VIEW_FAILURE',
    GENERATE_FAILURE: 'GENERATE_FAILURE',
    GENERATE_INITIATED: 'GENERATE_INITIATED',
    GENERATE_IN_PROGRESS: 'GENERATE_IN_PROGRESS',
    DOWNLOAD_SUCCESS: 'DOWNLOAD_SUCCESS',
    DOWNLOAD_FAILURE: 'DOWNLOAD_FAILURE',
    DOWNLOAD_INITIATED: 'DOWNLOAD_INITIATED',
    DELETE_SUCCESS: 'DELETE_SUCCESS',
    DELETE_FAILURE: ' DELETE_FAILURE',
    // VIEW: 'view',
    DOWNLOAD: 'download',
    DELETE: 'delete',
    REGENERATE: 'regenerate'
  };

  static FLOWSHEETS_SCREENS = {
    FLOWSHEET_GROUP: 'flowsheet_group',
    FLOWSHEET_TYPE: 'FlowsheetType',
    Flowsheet_Type: 'Flowsheet Type',
    PARAMETER_NAME: 'ParameterName',
    Parameter_Name: 'Parameter Name',
    Result_Name: 'Result Name',
    RESULT_NAME: 'ResultName',
    ID_KEY: '@@@Bytepad@@@',
    FLOWSHEET_TYPE_COLUMN: '__row_group_by_columns_group_FlowsheetType__'
  };

  static VITAL_SCREENS = {
    VITAL_GROUP: 'vital_group',
    ID_KEY: '@@@Bytepad@@@',
    VITAL_NAME_COLUMN: 'VitalName',
    Vital_Name: 'Vital Name',
    VitalName: 'Vital Name',
    VITAL: 'vital',
    GROWTH_CHART: 'growth_chart'
  };

  static STATIC_VALUES = {
    USER: 'By User',
    PATIENT: 'By Patient',
    PATIENT_LOG: 'patient-log',
    VIEW: 'view',
    ACCESSLOG: 'access-log'
  };

  static FILE_TYPES = {
    PDF: 'pdf'
  };

  static DATA_GRID_TYPES = {
    NOTES: 'notes',
    TABS: 'tabs',
    DATA_GRID: 'data-grid',
    CARD: 'cards',
    CARD_REPORT: 'report',
    LIST: 'list',
    MIXED: 'mixed',
    ROLES: 'roles',
    ENTERPRISEPERMISSIONS: 'enterprise_permission',
    USER_GROUPS: 'user-groups',
    TASKCARD: 'taskcards',
    SELECT: 'select',
    CHART: 'chart',
    SEXUAL_ORIENTATION_TAB: 'sexualorientation',
    DYNAMIC_UI: 'dynamic-ui'
  };

  static VITAL_FIELDS_MAPPING = {
    VITAL_NAME: 'VitalName',
    VitalName: 'Vital Name'
  };

  static CONFIG_FIELDS_TYPE = {
    DATE: 'date',
    DATE_TIME: 'date-time',
    BOOLEAN: 'boolean',
    SSN: 'ssn',
    CURRENCY: 'currency',
    US_PHONE: 'us-phone',
    SINGLE_SELECT: 'singleSelect',
    DATE_TIME_GRID: 'dateTime',
    BOOLEAN_CHECKBOX: 'boolean-checkbox'
  };

  static BOOLEAN_TYPES = {
    YES: 'Yes',
    NO: 'No'
  };

  static DOCUMENTS_ACTION_TYPES = {
    VIEW: 'view_details',
    DOWNLOAD: 'download_document'
  };

  static MODULE = {
    AUDIT_TRAILS: 'audit-trails',
    USER_ACCESS: 'user-access',
    AUDIT_LOGS: 'audit_logs',
    USER_ACCESS_LOGS: 'user-access-logs',
    USER_REPORT_LOG: 'user-report-log',
    PATIENT_REPORT_LOG: 'patient-report-log',
    AUDIT_LOG: 'audit-logs',
    MARKETPLACE: 'marketplace',
    FEEDBACK: 'feedback',
    LMS: 'LMS',
    INTEGRATIONS: 'integrations',
    PURGE_AND_LEGAL_HOLD: 'purge_and_legal_hold',
    PURGE: 'purge',
    EXTERNAL_AUDIT: 'external_audit',
    CLINICAL: 'clinical',
    PATIENT_ACCOUNTING: 'patient-accounting',
    SURGICAL: 'surgical',
    COURSE_CATALOG: 'course_management', // change this after route updated
    AUDIT_ACCESS_LOGS: 'audit_access_logs',
    PRE_POST_LEARNING: 'prepostlearning',
    SETTINGS: 'settings',
    ACCESS_LOGS: 'access-log',
    APPLICATION_LOGS: 'application-logs',
    PHARMACY: 'pharmacy',
    FILECABINET: 'file_cabinet',
    CMS: 'content-management',
    UNIQUE: 'uniqueId',
    RIS: 'ris',
    LIS: 'lis',
    HR: 'hr',
    PAYROLL: 'payroll',
    ENTERPRISE_SEARCH: 'enterprise_search',
    UAM: 'uam'
  };

  static MENU_ITEM = {
    PURGE: 'purge/add_new',
    LEGAL_HOLD: 'legal_hold/add_new',
    EXTERNAL_AUDIT: 'external_audit/add_new',
    USER_ACCESS: 'user/add_new'
  };

  static SUB_MODULE = {
    SUB_MODULE: 'sub_module',
    SUB_SUB_MODULE: 'sub-sub-section',
    BENEFITS: 'benefits',
    REPORTS: 'reports',
    ENCOUNTERS: 'encounters',
    ACCOUNTS: 'accounts',
    DEMOGRAPHICS: 'demographics',
    VITALS: 'vital',
    FLOW_SHEETS: 'flowsheets',
    EXAM_PROCEDURE_LIST: 'exam_procedure_list',
    RESULTS: 'results',
    PRODUCTINFO: 'productinfo',
    DOCUMENTS: 'documents',
    DICOM: 'dicom',
    VISITS: 'visits',
    CLINICAL_LOG: 'clinical_log',
    BILLING: 'billing',
    IMPLANT_AND_SUPPLIES: 'implant_supplies',
    ACCOUNT: 'account',
    INVOICE: 'invoice',
    TRANSFUSION: 'transfusion'
  };

static DOCUMENT_FORMATS = {
    unSupportedFormats: ['DOC', 'DOCX', 'XLSX', 'XLS', 'CSV', 'XML', 'JSON', 'MD', 'MDX', 'YAML', 'YML', 'LOG', 'SQL', 'EXE', 'DLL'],
    SupportedFormats: [
      'RTF',
      'TXT',
      'PDF',
      'JPG',
      'JPEG',
      'HTML',
      'HTM',
      'TIFF',
      'TIF',
      'PNG',
      'BMP',
      'GIF'
    ],

    iframeSupportedFormats: ['']
  };

  static PURGE_TERMS = {
    PURGE_INSERT: 'purgeInsert',
    PURGE: 'purge',
    ADD_NEW: 'add_new',
    LEGAL_HOLD: 'legal_hold',
    LEGAL_HOLD_INSERT: 'legalHoldInsert',
    PURGE_UPDATE: 'purgeUpdate',
    PURGE_SELECTION_LIST: 'purge_selection_list',
    RETENTION_YEARS: 'retention_years',
    RETENTION_MONTHS: 'retention_months',
    LEGAL_HOLD_DELETE: 'legalHoldDelete'
  };

  static REPORTS_TERMS = {
    ALL_SYSTEMS: 'All Systems',
    ALL: 'All',
    ENCOUNTERS: 'Encounters',
    PATIENT_DEMOGRAPHICS: 'Patient Demographics',
    INSURANCES: 'Insurances',
    RELATIONS: 'Relations',
    FOR_SELECTED_ITEMS: 'For Selected Encounters Only',
    FOR_SELECTED_DATE_RANGE: 'For Selected Date Range',
    NONE: 'None',
    CLINICAL: 'Clinical',
    GENERATE_INITIATED: 'GENERATE_INITIATED',
    DOCUMENTS_SEPARATOR: ' $ '
  };

  static LOGIN_TYPE = {
    ALL: 'all',
    LOCAL: 'local',
    ADFS: 'adfs',
    AZURE: 'azure',
    OAUTH: 'oauth'
  };

  static USER_ACCESS = {
    USER_GROUPS: 'user-groups',
    USER_GROUP: 'user_group',
    SELECTED_GROUP: 'selected_group',
    ROLES: 'roles',
    SELECTED_ROLE: 'selected_role',
    ENTERPRISEPERMISSION: 'enterprise_permission',
    SELECTED_TAB:'selected_tab'
  };

  static USER_GROUP = {
    BY_ROLE: 'updateByRole',
    SOFT_DELETE_BY_ROLE: 'softDeleteByrole',
    BY_USER: 'updateByUser',
    ROLES_IN_THIS_GROUP: 'Roles In This Group',
    USERS_IN_THIS_GROUP: 'Users In This Group',
    USERS_NOT_IN_THIS_GROUP: 'Users Not In This Group',
    NONE: 'None'
  };

  static EPIC_TERMS = {
    BASE: 'epic',
    LAUNCH: 'launch',
    ISS: 'iss',
    CODE: 'code',
    AUTHORIZATION_CODE: 'authorization_code'
  };

  static ATHENA_TERMS = {
    BASE: 'athena',
    LAUNCH: 'launch',
    ISS: 'iss',
    CODE: 'code',
    AUTHORIZATION_CODE: 'authorization_code',
    SCOPES:
      'launch openid profile fhirUser user/Organization.rs user/Patient.rs user/Practitioner.rs patient/Organization.rs patient/Patient.rs patient/Practitioner.rs',
    STATE: 'bytepad-state',
    NONCE: 'bytepad-nonce'
  };

  static ABNORMAL_FLAG = {
    TEXT: 'AbnormalFlagText'
  };

  static COMMON = {
    LOGIN_SUCCESS: 'Login Success',
    LOGOUT_SUCCESS: 'Logout Success',
    DOWNLOADED_REPORTS: 'Downloaded Reports',
    DELETED_REPORTS: 'Deleted Reports',
    REGENERATED_REPORTS: 'Regenerated Reports',
    GENERATED_STANDARD_PSR_REPORTS: 'Generated Standard PSR Reports',
    GENERATED_CUSTOMS_REPORTS: 'Generated Customs Reports',
    VIEWED_DOCUMENT: 'Viewed Document',
    DOWNLOADED_DOCUMENT: 'Downloaded Document',
    VIEWED_VITALS: 'Viewed Vitals',
    VIEWED_FLOWSHEET: 'Viewed Flowsheet',
    VIEWED_USERS: 'Viewed Users',
    VIEWED_USER_GROUPS: 'Viewed User Groups',
    VIEWED_ROLES: 'Viewed Roles',
    GENERATE_OTP: 'Generate OTP'
  };

  static RCM_PATIENT_ACCOUNTING = {
    PAYMENT: {
      AUTO_POST: 'auto_post',
      MANUAL_POST: 'manual_post'
    },
    REPORT: {
      PAYMENT_RECONCILIATION: 'payment_reconciliation'
    },
    TABS: {
      DASHBOARD: 'dashboard',
      PATIENT: 'patient',
      PAYMENT: 'payment',
      AR_WORKDOWN: 'ar_workdown',
      REPORT: 'report'
    }
  };

  static IS_BH = {
    VIEW_RESTRICTED_DATA: 'View Restricted Data',
    DIALOG_CLOSE_MSG: 'No selection was made for viewing restricted data.'
  };
}

export default FormConstants;
